export const RED = '#fa541c';
export const ORANGE = '#faad14';
export const YELLOW = '#fadb14';
export const GREEN = '#a0d911';
export const DARK_GREEN = '#52c41a';
export const BLUE = '#1890ff';
export const DARK_BLUE = '#2f54eb';
export const PURPLE = '#722ed1';
export const PINK = '#eb2f96';
export const GRAY = '#bfbfbf';
export const BLACK3 = '#303030';
export const BLACK2 = '#202020';
export const BLACK1 = '#101010';